import React, { useState, useRef } from "react";

import * as Material from "@mui/material";

import LoadingButton from "@mui/lab/LoadingButton";

import './index.scss';

/**
 * 
 * @param {variant: "default" | "rounded" | "text" | "dashed"} param0 
 * @param {color: "white" | "black" | "primary" | "error" | "warning" | "info" | "success" | "inverse"} color
 * @param {size: "small" | "medium" | "large"} size
 */

export default function Button({ children, text, onClick, disabled = false, className = "", variant = "default", loading = false, color = "primary", size = "medium", tooltip, endIcon, startIcon, icon = null, fullWidth = false, ...props }) {
  const [_loading, _setLoading] = useState(loading);
  const buttonRef = useRef(null);
  const [ripples, setRipples] = useState([]);

  const createRipple = (event) => {
    const button = buttonRef.current;
    if (!button) return;

    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = event.clientX - rect.left - size / 2;
    const y = event.clientY - rect.top - size / 2;

    const ripple = {
      id: Date.now(),
      x,
      y,
      size
    };

    setRipples(prev => [...prev, ripple]);

    setTimeout(() => {
      setRipples(prev => prev.filter(r => r.id !== ripple.id));
    }, 600);
  };

  async function _onClick(event) {
    if (!disabled && !_loading) {
      createRipple(event);
    }
    if (!onClick) return;
    _setLoading(true);

    try {
      await onClick(event);
    } catch (error) {
      console.error(error);
    }

    _setLoading(false);
  }

  return (
    <Material.Tooltip arrow title={tooltip}>
      <button
        ref={buttonRef}
        disabled={_loading || disabled}
        className={`
          CustomBtn_platform-button-base 
          ${className} 
          CustomBtn_${variant} 
          ${icon ? "CustomBtn_icon" : ""} 
          CustomBtn_${color} 
          CustomBtn_${size} 
          ${startIcon ? "CustomBtn_has-start-icon" : ""} 
          ${endIcon ? "CustomBtn_has-end-icon" : ""} 
          ${(disabled || _loading) ? "CustomBtn_disabled" : ""}
        `}
        style={{
          width: fullWidth ? "100%" : "auto"
        }}
        onClick={_onClick}
        variant="contained"
        {...props}
      >
        {ripples.map(ripple => (
          <span
            key={ripple.id}
            className="CustomBtn_wave-effect"
            style={{
              left: `${ripple.x}px`,
              top: `${ripple.y}px`,
              width: `${ripple.size}px`,
              height: `${ripple.size}px`
            }}
          />
        ))}
        {
          startIcon && !_loading && !loading && (
            <div className="CustomBtn_button-icon">
              {startIcon}
            </div>
          )
        }
        {
          icon && !_loading && !loading && (
            <div className="CustomBtn_button-icon">
              {icon}
            </div>
          )
        }
        {(_loading || loading) && (
          <Material.CircularProgress
            className="CustomBtn_loader"
            color="white"
          />
        )}
        {
          (children || text) && !icon && (
            <span className="CustomBtn_button-text">{children || text}</span>
          )
        }

        {
          endIcon && !_loading && !loading && (
            <div className="CustomBtn_button-icon">
              {endIcon}
            </div>
          )
        }
      </button>
    </Material.Tooltip>
  )
}
